<div class="checkbox-container" #container tabindex="0" (click)="refocusContainer()" 
    [class.checked]="option.groupHeaderItem.checked" >
    <div class="group-header"> 
        <div class="flex flex-row space-x-2">
            <app-checkbox (checkBoxToggled)="groupItemToggled($event)" (change)="groupItemChanged()"
                [checked]="option.groupHeaderItem.checked" [id]="option.groupHeaderItem.id">
                <span class="name">{{option.groupHeaderItem.name}}</span>
            </app-checkbox>
            <div class="h-5 px-2.5 py-0.5 bg-gray-100 rounded-[10px] justify-center items-center inline-flex" [class.hidden]="selectedItemsCount === 0">
                <div class="text-center text-gray-500 text-xs font-medium leading-none">{{selectedItemsCount}} {{countedItemsHeader}}{{selectedItemsCount === 1 ? '' : 's'}}</div>
            </div>
        </div>
      <div class="flex flex-row space-x-3 items-center cursor-pointer">
        <div class="select-clear-all" [class.hidden]="!isOpen">
            <span [hidden]="selectedItemsCount === option.groupItems.length" (click)="selectAll()">Select All</span>
            <span [hidden]="selectedItemsCount !== option.groupItems.length" (click)="clearAll()">Clear All</span>
        </div>
        <img [class.opened]="isOpen" class="cursor-pointer" src="assets/icons/icon-chevron-down-dark.svg" alt="chevron-down"
            (click)="isOpen = !isOpen" />
      </div>
    </div>
   <div class="items" [class.hidden]="!isOpen">
    <app-checkbox class="block mb-2"
        *ngFor="let item of option.groupItems; let i = index"
        (change)="itemChanged(item)"
        [id]="option.groupHeaderItem.name + item.id"
        [checked]="item.checked"
        [checkedAlternativeStyle]="true"
    >
        <span class="name"
        >{{item.name}}
        </span>
    </app-checkbox>
   </div>
</div>